


import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';

import "./styles/buttons.css"
import "./styles/colors.css"

import "./styles/globals.css"
import "./styles/inputs.css"

import "./styles/row.css"
import "./styles/screens.css"

import "./styles/fonts.css"

const rootElement = document.getElementById('root');
createRoot(rootElement).render(<App />);

